import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ExpertInstructor.css";

const coaches = [
  {
    name: "Mrs. Ritu Chouhan",
    title: "Director",
    description:
      "Director of the RDTC.",
    image: "images/Director.jpeg", // Replace with actual image path
  },
  {
    name: "	Shri Vikram Singh Rathore",
    title: "RDTC Project Coordinator",
    description:
      "RDTC Project Coordinator of RDTC.",
    image: "images/Vik.jpeg",
  },
  {
    name: "Shri Surypal Singh",
    title: "Project Co-Coordinator",
    description:
      "Project Co-Coordinator of RDTC",
    image: "images/Surypal Singh.jpg",
  },
  {
    name: "	Shri Man Singh Rawat",
    title: "	Instructor",
    description:
      "	Instructor of RDTC",
    image: "images/Man Singh.jpg",
  },
  {
    name: "Shri Bharat Raj Gujar",
    title: "	Instructor",
    description:
      "	Instructor of RDTC",
    image: "images/Bharat Raj.jpg",
  },

  {
    name: "Shri Narendera Kumar Sharma",
    title: "Accountant",
    description:
      "	Accountant of RDTC",
    image: "images/Narendra.jpg",
  },
];

const ExpertInstructor = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Number of cards visible at once
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <div className="next-arrow">›</div>,
    prevArrow: <div className="prev-arrow">‹</div>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="coaches-section">
      <h2 className="coaches-title">Meet Our Experts</h2>
      <Slider {...settings} className="coaches-slider">
        {coaches.map((coach, index) => (
          <div key={index} className="coach-card">
            <img src={coach.image} alt={coach.name} className="coach-image" />
            <h3 className="coach-name">{coach.name}</h3>
            {/* <p className="coach-location">{coach.location}</p> */}
            <h4 className="coach-title">{coach.title}</h4>
            <p className="coach-description">{coach.description}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ExpertInstructor;
